import * as actions from "store/actions";
import { config } from "config";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import { decodeHandler, decryptData, encodeHandler } from "utils";

function socket(dispatch, state) {
  const wsConnection = new WebSocket(config.WS_URL, [
    "web-token",
    localStorage.getItem("token"),
    encodeHandler(decryptData(localStorage.getItem("mirrorId")))
  ]);
  console.log(wsConnection);
  wsConnection.onopen = () => {
    dispatch(actions.PNSDown(false));
    if (decryptData(localStorage.getItem("mirrorId"))) {
      const req = {
        action: "newWebClient",
        loginId: decryptData(localStorage.getItem("mirrorId"))
      };

      console.log(req);
      wsConnection.send(JSON.stringify(req));
    }
  };

  wsConnection.onmessage = event => {
    // console.log(event);
    const data = JSON.parse(event.data);

    console.log(JSON.parse(data.data), data.action);
    switch (data && data.action) {
      case "cloudBackupProgress":
        dispatch(actions.updateBackupProgress(JSON.parse(data.data)));
        break;
      case "backupSetCompletion":
        dispatch(actions.backupSetCompleted(JSON.parse(data.data)));
        setTimeout(() => {
          dispatch(actions.fetchAccountDetailsStart());
        }, 5000);
        setTimeout(() => {
          dispatch(actions.removeBackupTempStatus(JSON.parse(data.data)));
        }, 5000);
        setTimeout(() => {
          dispatch(
            actions.fetchClientStatusStart(
              JSON.parse(data.data).clientUUID,
              "cloudUsage"
            )
          );
        }, 2000);
        break;
      case "backupSetFailure":
        dispatch(actions.backupSetFailed(JSON.parse(data.data)));
        setTimeout(() => {
          dispatch(actions.removeBackupTempStatus(JSON.parse(data.data)));
        }, 5000);
        break;
      case "newBackupClientInfo":
        dispatch(actions.setIsFirstTime());
        dispatch(actions.addNewBackupClient(JSON.parse(data.data)));
        dispatch(
          actions.fetchClientServerIPAddressStart(JSON.parse(data.data))
        );
        break;
      case "backupSettingsChanged":
        dispatch(actions.backupSettingsChanged(JSON.parse(data.data)));
        dispatch(actions.fetchGroupsStart());
        const backupPlans = state().backupPlan.backupPlans.data;
        const deviceId = JSON.parse(data.data).clientUUID;
        if (backupPlans) {
          const plan = Object.values(backupPlans).find(data =>
            data.devices.find(dev => dev.clientUUID === deviceId)
          );
          if (plan) {
            dispatch(actions.fetchBackupPlansSettingStart(plan.planId));
            dispatch(
              actions.showNotificationWithTimeout("backupPlan", {
                status: NOTIFICATION_STATUS.success.name,
                msg:
                  "Devices in " + decodeHandler(plan.planName) + " is updated"
              })
            );
          }
        }
        break;
      case "configureBackupClient":
        dispatch(actions.configureBackupClient(JSON.parse(data.data)));
        break;
      case "backupMachineStatus":
        dispatch(actions.updateBackupMachineStatus(JSON.parse(data.data)));
        if (JSON.parse(data.data).machineStatus === "offline") {
          dispatch(
            actions.fetchClientStatusStart(
              JSON.parse(data.data).clientUUID,
              "status"
            )
          );
          dispatch(
            actions.fetchClientStatusSuccess(JSON.parse(data.data), "errorCode")
          );
        }
        break;
      case "backupScheduleUpdated":
        dispatch(actions.updateClientInfo(JSON.parse(data.data)));
        break;
      case "backupMachinesStatus":
        dispatch(actions.updateBackupMachinesStatus(JSON.parse(data.data)));
        break;
      case "stopCloudBackup":
        dispatch(actions.stopBackup(JSON.parse(data.data)));
        setTimeout(() => {
          dispatch(actions.removeBackupTempStatus(JSON.parse(data.data)));
        }, 5000);
        break;
      case "cloudRestoreProgress":
        dispatch(actions.updateRestoreProgress(JSON.parse(data.data)));
        break;
      case "restoreSetCompletion":
        dispatch(actions.restoreSetCompletion(JSON.parse(data.data)));
        setTimeout(() => {
          dispatch(actions.removeRestoreState(JSON.parse(data.data)));
        }, 5000);
        break;
      case "updatedVolumeList":
        dispatch(actions.populateUpdatedVolumes(JSON.parse(data.data)));
        dispatch(actions.populateUpdatedVolumesFR(JSON.parse(data.data)));
        break;
      case "restoreSetFailure":
        dispatch(actions.restoreSetFailure(JSON.parse(data.data)));
        setTimeout(() => {
          dispatch(actions.removeRestoreState(JSON.parse(data.data)));
        }, 5000);
        break;
      case "cancelRestoreResponse":
        dispatch(actions.stopRestore(JSON.parse(data.data)));
        setTimeout(() => {
          dispatch(actions.removeRestoreState(JSON.parse(data.data)));
        }, 5000);
        break;
      case "imageRestoreProgress":
        dispatch(actions.updateImageRestoreProgress(JSON.parse(data.data)));
        break;
      case "removeClientResponse":
        setTimeout(() => {
          dispatch(actions.removeClientFromList(JSON.parse(data.data)));
        }, 1800);
        break;
      case "enumFolderResponse":
        dispatch(actions.enumFolderResponse(JSON.parse(data.data)));
        break;
      case "createFolderResponse":
        dispatch(actions.createFolderResponse(JSON.parse(data.data)));
        break;
      case "accountActivityChangedResponse":
        dispatch(actions.accountSettingsChanged());
        break;
      case "upgradePlan":
        dispatch(actions.changeToPaidPlan(JSON.parse(data.data)));
        dispatch(actions.fetchRenewalPriceStart());
        dispatch(actions.fetchCCDetailsStart());
        break;
      case "backupPlanSettingsChanged":
        JSON.parse(data.data).clientUUIDs.forEach(uuid =>
          dispatch(actions.backupSettingsChanged({ clientUUID: uuid }))
        );
        JSON.parse(data.data).planIDs.forEach(id =>
          dispatch(actions.fetchBackupPlansSettingStart(id))
        );
        dispatch(actions.fetchGroupsStart());

        break;
      default:
        console.log("Excess WebSocket Calls!!!");
    }
  };

  wsConnection.onclose = e => {
    if (e.code === 1003) {
      dispatch(actions.logoutUser(false));
    } else if (
      (e.code === 1001 && window.browserName !== "firefox") ||
      e.code === 1006 ||
      e.code === 1012 ||
      e.code === 1008
    ) {
      // wsConnect();
      dispatch(actions.initiateNewSocketConnection());
      if (window.browserName === "firefox") {
        if (e.code !== 1001) dispatch(actions.PNSDown(true));
      }
      if (e.code !== 1008) dispatch(actions.PNSDown(true));
    } else if (
      e.code !== 1000 &&
      e.code === 1001 &&
      window.browserName !== "firefox"
    )
      dispatch(actions.PNSDown(true));
  };

  wsConnection.onerror = e => {
    console.log("Socket connection error ===>" + e);
  };

  function wsConnect() {
    socket(dispatch, state);
  }

  return { wsConnection, wsConnect };
}

export default socket;
